import clsx from "clsx";
import { KTIcon } from "../../helpers";
import { HeaderUserMenu } from "./header-menus/HeaderUserMenu";
import { useLayout } from "../../layout/core";
import profile from "assets/images/blank.png";
import { ThemeModeType, useThemeMode } from "hooks‬/theme";
import { useEffect } from "react";
import { updateSystemModeUserPreferences } from "services/userManagementAPIs";
import {
  colorDensityDetector,
  getPrimaryColor,
  updateColors,
} from "components/theme/ThemeHelpers";
import { useAuth } from "hooks‬/Auth";
const itemClass = "ms-1 ms-lg-3";
const userAvatarClass = "symbol-35px symbol-md-40px";
// const btnIconClass = "fs-1";
function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const RightHeaderContainer = () => {
  const { mode, updateMode, updateMenuMode } = useThemeMode();
  const {
    fetchUserPreferencesHandler,
    userPreference,
    userDetails,
    setUserPreference,
  } = useAuth();
  const updateSystemUserPreferencesHandler = async (_mode: string) => {
    try {
      await updateSystemModeUserPreferences(capitalizeFirstLetter(_mode))
        .then(() => {
          setUserPreference((previousData) => ({
            ...previousData,
            systemMode: _mode,
          }));
        })
        .catch((error: any) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  };

  const switchMode = (_mode: ThemeModeType) => {
    updateMenuMode(_mode);
    updateMode(_mode);
    colorDensityDetector(getPrimaryColor(), _mode);
    updateSystemUserPreferencesHandler(_mode);
    if (userPreference.themeColor) {
      if (userPreference.themeColor.startsWith("#")) {
        updateColors(userPreference.themeColor);
      } else {
        updateColors("#" + userPreference.themeColor);
      }
    }
  };

  useEffect(() => {
    updateMenuMode(userPreference?.systemMode.toLowerCase());
    updateMode(userPreference?.systemMode.toLowerCase());
    // eslint-disable-next-line
  }, [userPreference?.systemMode]);

  useEffect(() => {
    fetchUserPreferencesHandler();
    // eslint-disable-next-line
  }, []);

  const { config } = useLayout();
  return (
    <div className="app-navbar flex-shrink-0">
      {mode === "light" ? (
        <div
          className={clsx("app-navbar-item ", itemClass)}
          onClick={() => {
            switchMode("dark");
          }}
        >
          <i
            className="ki-outline ki-moon text-primary-white pointer"
            style={{ fontSize: "22px" }}
          ></i>
        </div>
      ) : (
        <div
          className={clsx("app-navbar-item ", itemClass)}
          onClick={() => {
            switchMode("light");
          }}
        >
          <i
            className="ki-outline ki-sun text-primary-white pointer"
            style={{ fontSize: "24px" }}
          ></i>
        </div>
      )}

      <div className={clsx("app-navbar-item", itemClass)}>
        <div
          className={clsx("  px-1   cursor-pointer symbol", userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach="parent"
          data-kt-menu-placement="bottom-end"
        >
          {userDetails?.profileImage ? (
            <div className="symbol symbol-35px me-0">
              <img
                alt="Logo"
                className="object-fit-cover"
                src={userDetails?.profileImage ?? profile}
              />
            </div>
          ) : (
            <span className="pt-1">
              <KTIcon
                iconName="user"
                className="text-primary-white fs-24px m-0 p-0"
              />
            </span>
          )}
        </div>
        <HeaderUserMenu />
      </div>

      {config.app?.header?.default?.menu?.display && (
        <div
          className="app-navbar-item d-lg-none ms-2 me-n3"
          title="Show header menu"
        >
          {/* <div
            className="btn btn-icon btn-active-color-primary w-35px h-35px"
            id="n_one_app_header_menu_toggle"
          >
            <KTIcon iconName="text-align-left" className={btnIconClass} />
          </div> */}
        </div>
      )}
    </div>
  );
};

export { RightHeaderContainer };
